import { useState, useMemo } from "react";

import { 
  useReactTable, 
  getCoreRowModel, 
  getExpandedRowModel, 
  flexRender 
} from '@tanstack/react-table';

export const AssortmentFinancialTable = ({ ctx }) => {
  const [expanded, setExpanded] = useState({});

  const { tableData = [], columns } = ctx || {};

  const data = useMemo(() =>
    tableData.map(row => ({
      ...row,
      subRows: row.items.map(item => ({
        ...row,
        ...item,
        level1: item.level4,
      })),
    })), [tableData]
  );

  const table = useReactTable({
    data,
    columns,
    state: { expanded },
    onExpandedChange: setExpanded,
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getSubRows: row => row.subRows,
  });

  const headStyle = {
    padding: "9px 12px",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: "700",
    color: "#555",
    letterSpacing: "0.03em",
  };

  return (
    <table className="table table-hover" style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        {table.getHeaderGroups().map(headerGroup => (
          <tr
            key={headerGroup.id}
            style={{ borderBottom: "1.5px solid #f0f0f0", backgroundColor: "#fafafa" }}
          >
            {headerGroup.headers.map((header, i) => (
              <th
                key={header.id}
                style={i === 0 ? { ...headStyle, textAlign: "left", padding: "9px 16px" } : headStyle}
              >
                {flexRender(header.column.columnDef.header, header.getContext())}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody>
        {table.getRowModel().rows.map((row, rowIdx) => {
          const isSubRow = row.depth > 0;

          return (
            <tr
              key={row.id}
              onClick={() => row.toggleExpanded()}
              style={{
                borderBottom: `1px solid ${isSubRow ? '#f0f0f0' : '#f5f5f5'}`,
                cursor: row.getCanExpand() ? 'pointer' : 'default',
                backgroundColor: 
                  isSubRow
                    ? rowIdx % 2 === 0 ? '#f7f7f7' : '#f2f2f2'
                    : rowIdx % 2 === 0 ? '#fff' : '#fafafa',
                transition: 'background-color 0.12s',
              }}
            >
              {row.getVisibleCells().map((cell, cellIdx) => (
                <td
                  key={cell.id}
                  style={
                    cellIdx === 0
                      ? {
                          padding: isSubRow ? '9px 16px 9px 40px' : '11px 16px',
                          fontSize: isSubRow ? '12px' : '13px',
                          fontWeight: isSubRow ? '400' : '700',
                          color: isSubRow ? '#555' : '#1a1a1a',
                          textAlign: 'left',
                        }
                      : {
                          padding: '10px 12px',
                          textAlign: 'center',
                          fontSize: isSubRow ? '12px' : '13px',
                          color: '#444',
                        }
                  }
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};